import React from 'react'
import store from '../../api/store'
import { StackView, Button, Alert, Icon } from '@planningcenter/tapestry-react'
import { Heading, Text, Code, Link } from './typography'

const ErrorUI = ({ error, children, onRetry }) => {
  if (!error) {
    return children
  }
  return (
    <StackView axis="vertical" alignment="start" spacing={2}>
      {process.env.NODE_ENV === 'development' &&
        store.get('apiSource') === 'development' && (
          <Alert type="warning" padding={1} width="100%">
            <StackView axis="horizontal" alignment="center" spacing={1}>
              <Icon
                name="general.exclamationCircle"
                size="lg"
                color="warning-dark"
              />
              <Text size={4}>
                If your API source is set to "development", make sure{' '}
                <Link to="https://github.com/ministrycentered/pco-box" external>
                  <Code>pco-box</Code>
                </Link>{' '}
                is running.
              </Text>
            </StackView>
          </Alert>
        )}
      <Heading lineHeight="100%">Error:</Heading>
      <Text>{error.message}</Text>
      {onRetry && (
        <Button display="inline-block" theme="primary" onClick={onRetry}>
          Retry
        </Button>
      )}
    </StackView>
  )
}

export default ErrorUI
